import { defineRecipe } from '@chakra-ui/react/styled-system';

import { base, defaultVariants, singleLineInputOverrides, variants } from '../common/InputAndTextarea.common';

const inputRecipe = defineRecipe({
  className: 'input',
  base: {
    ...base,
    ...singleLineInputOverrides,
    // Pin the input to the size-variant's --input-height so layout stays deterministic regardless
    // of padding/font drift.
    height: 'var(--input-height)',
  },
  variants,
  defaultVariants,
});

export default inputRecipe;
